import { ActionType, initialFilters } from '.';

import { IUsersFilterAndSortParams } from '../../../../types/type';

export const tableFiltersReducer = (
  filtersState: IUsersFilterAndSortParams,
  action: IAction,
): IUsersFilterAndSortParams => {
  const { type, paging: page, sorting: sort, userLogin, displayName } = action;
  switch (type) {
    case ActionType.SET_PAGE:
      // eslint-disable-next-line
      return { ...filtersState, paging: page! };
    case ActionType.SET_SORT:
      // eslint-disable-next-line
      return { ...filtersState, sorting: sort! };
    case ActionType.SET_USER_LOGIN:
      return { ...filtersState, userLogin };
    case ActionType.SET_DISPLAY_NAME:
      return { ...filtersState, displayName };
    case ActionType.RESET:
      return initialFilters;
    default:
      return filtersState;
  }
};

interface IAction extends Partial<IUsersFilterAndSortParams> {
  type: ActionType;
}
